import RegisterContext from "../../components/contexts/RegisterContext"
import TopNavbar from "../../components/top-navbar/TopNavbar"
import ResetBox from "../../components/reset-box/ResetBox";
import LoginBox from "../../components/login/LoginBox";
import './PasswordReset.css'
// import '../components/login/LoginBox.css'
import {useContext, useEffect} from 'react'





function PasswordReset() {
   // variable to track user status
//    const {user} = useContext(RegisterContext);

   useEffect(() => {
      document.title = "Reset Password";  
      document.documentElement.lang = "en";
   }, []);

   return(
      <div id="reset-body">
      <div>
        <TopNavbar />
        <div className = "reset-main-screen">
            <ResetBox />
         </div>
      </div>
      </div>
   )
}
export default PasswordReset